import { useStaticQuery, graphql } from "gatsby"

/**
 * Hook to fetch testimonials that are promoted to homepage
 * @return {Promise<TestimonialItem[]>}
 */
const useHomepageTestimonialsData = () => {
  const data = useStaticQuery(graphql`
    query HomepageTestimonialsQuery {
      allParagraphCountryTestimonial(
        filter: { promote_to_homepage: { eq: true } }
        limit: 10
      ) {
        nodes {
          id
          title
          testimonial
          country {
            id
            title
            slug
            hero {
              images {
                variants {
                  alt
                  height
                  style
                  title
                  url
                  width
                }
              }
            }
          }
        }
      }
      allNodeStaffProfile {
        nodes {
          id
          external_id
          title
          position
          slug
          photograph {
            variants {
              alt
              height
              style
              title
              url
              width
            }
          }
          photo {
            variants {
              alt
              height
              style
              title
              url
              width
            }
          }
          country_testimonial {
            id
            external_id
            title
            testimonial
            promote_to_homepage
          }
        }
      }
    }
  `)

  const getHomepageTestimonials = () => {
    const testimonials = data.allParagraphCountryTestimonial.nodes || []
    const allStaffProfiles = data.allNodeStaffProfile.nodes || []

    // Process testimonials with staff information
    const processedTestimonials = testimonials.map((testimonial) => {
      // Find the staff member who wrote this testimonial
      const staffMember = allStaffProfiles.find((staff) =>
        staff.country_testimonial?.some((ct) => ct.id === testimonial.id)
      )

      return {
        ...testimonial,
        staff: staffMember ? {
          id: staffMember.id,
          title: staffMember.title,
          position: staffMember.position,
          slug: staffMember.slug,
          photograph: staffMember.photograph,
          photo: staffMember.photo
        } : null
      }
    }).filter((testimonial) => testimonial.staff) // Only include testimonials with associated staff

    return processedTestimonials
  }

  return {
    getHomepageTestimonials,
  }
}

export default useHomepageTestimonialsData
